import { CURRENCY_MAP } from '@/components/prod/center/components/TemuInfoForm/config.js';
export const getPriceName = (platform) => {
    platform = platform == 1688 ? 'alibaba' : platform
    const names = {
        fxg: {
            name: '抖音',
            sales: '价格',
            market: '',
        },
        kuaishou: {
            name: '快手',
            sales: '价格',
            market: '',
        },
        jd: {
            name: '京东',
            sales: '京东价',
            market: '市场价',
        },
        tb: {
            name: '淘宝',
            sales: '价格',
            market: '',
        },
        tm: {
            name: '天猫',
            sales: '价格',
            market: '',
        },
        pdd: {
            name: '拼多多',
            sales: '拼单价',
            market: '单买价',
        },
        wxxd: {
            name: '微信小店',
            sales: '售卖价',
            market: '市场价',
        },
        tjb: {
            name: '淘特',
            sales: '特价',
            market: '划线价',
        },
        alibaba: {
            name: '1688',
            sales: '单价',
            market: '',
        },
        yz: {
            name: '有赞',
            sales: '价格',
            market: '划线价',
        },
        wxsph: {
            name: '微信视频号',
            sales: '售卖价',
            market: '',
        },
        xhs: {
            name: '小红书',
            sales: '售价',
            market: '',
        },
        xy: {
            name: '闲鱼',
            sales: '售价',
            market: '',
        },
        wd: {
            name: '微店',
            sales: '商品价格',
            market: '划线价',
        },
        pddtemu:{
            name: 'Temu全托管',
            // sales: '建议零售价',
            // market:'申报价',
            currencyList:Object.values(CURRENCY_MAP),
            currencyMap:CURRENCY_MAP,
            configList:[
                {
                    prop:'retailPriceConf',
                    name:'建议零售价',
                    priceList:[
                        {label:'基础资料销售价',value:'base_sales'},
                        {label:'基础资料市场价',value:'base_market'},
                        {label:'基础资料成本价',value:'base_purchase'},
                    ],
                    hasExchangeRate:true,
                },
                {
                    prop:'supplierPriceConf',
                    name:'申报价',
                    priceList:[
                        {label:'基础资料销售价',value:'base_sales'},
                        {label:'基础资料市场价',value:'base_market'},
                        {label:'基础资料成本价',value:'base_purchase'},
                    ],
                },
            ],
        },
        pddtemu_btg:{
            name: 'Temu半托管',
            sales: '建议零售价',
            market:'申报价',
        },
    }
    return names[platform]
};
